import Patterns from '../patterns.js';

export default [
  {
    name: 'wbscId',
    label: {
      cs: 'WBSC ID',
      en: 'WBSC ID',
    },
    type: 'integer',
    min: 1,
    max: 999999,
  },
  {
    name: 'shortcut',
    label: {
      cs: 'Zkratka',
      en: 'Shortcut',
    },
    type: 'string',
    pattern: Patterns.ONLY_LOWER_CASE,
    patternErrorMessage: Patterns.ONLY_LOWER_CASE_MESSAGE,
    minLength: 3,
    maxLength: 3,
    required: true,
  },
  {
    name: 'name.cs',
    label: {
      cs: 'Název [CS]',
      en: 'Name [CS]',
    },
    type: 'string',
    pattern: Patterns.ACCENTS,
    patternErrorMessage: Patterns.ACCENTS_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'name.en',
    label: {
      cs: 'Název [EN]',
      en: 'Name [EN]',
    },
    type: 'string',
    pattern: Patterns.ACCENTS,
    patternErrorMessage: Patterns.ACCENTS_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'group',
    label: {
      cs: 'Skupina',
      en: 'Group',
    },
    type: 'string',
    pattern: Patterns.ONLY_LOWER_CASE,
    patternErrorMessage: Patterns.ONLY_LOWER_CASE_MESSAGE,
    minLength: 1,
    maxLength: 1,
  },
  {
    name: 'founded',
    label: {
      cs: 'Založeno',
      en: 'Founded',
    },
    type: 'integer',
    min: 1900,
    max: new Date().getFullYear() + 1,
  },
  {
    name: 'web',
    label: {
      cs: 'Web',
      en: 'Web',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
    required: true,
  },
  {
    name: 'wbscEurope',
    label: {
      cs: 'WBSC Europe',
      en: 'WBSC Europe',
    },
    type: 'integer',
    min: 1,
    max: 999,
  },
  {
    name: 'facebook',
    label: {
      cs: 'Facebook',
      en: 'Facebook',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'instagram',
    label: {
      cs: 'Instagram',
      en: 'Instagram',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'twitter',
    label: {
      cs: 'Twitter',
      en: 'Twitter',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'youtube',
    label: {
      cs: 'YouTube',
      en: 'YouTube',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'standings.0',
    label: {
      cs: 'Umístění (2021)',
      en: 'Standings (2021)',
    },
    type: 'integer',
    min: 1,
    max: 20,
  },
  {
    name: 'standings.1',
    label: {
      cs: 'Umístění (2019)',
      en: 'Standings (2019)',
    },
    type: 'integer',
    min: 1,
    max: 20,
  },
  {
    name: 'standings.2',
    label: {
      cs: 'Umístění (2016)',
      en: 'Standings (2016)',
    },
    type: 'integer',
    min: 1,
    max: 20,
  },
  {
    name: 'standings.3',
    label: {
      cs: 'Umístění (2014)',
      en: 'Standings (2014)',
    },
    type: 'integer',
    min: 1,
    max: 20,
  },
  {
    name: 'content.cs',
    label: {
      cs: 'Obsah [CS]',
      en: 'Content [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 5096,
  },
  {
    name: 'content.en',
    label: {
      cs: 'Obsah [EN]',
      en: 'Content [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 5096,
  },
  {
    name: 'slot',
    label: {
      cs: 'Slot',
      en: 'Slot',
    },
    type: 'integer',
    min: 0,
    max: 99,
  },
];
